import { env } from "../config";

export const API_ENDPOINTS = {
    asset: {
        get: "/v1/asset/download",
        getImageAsSrc: (assetId: string) => `${env.API_ENDPOINT}/v1/asset/download?AssetId=${assetId}`,
    },
};
